import React, { useState } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || import.meta.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

console.log('🔧 TestAuth - Configuration:', {
  BACKEND_URL,
  API,
  hasBackendUrl: !!BACKEND_URL
});

const TestAuth = () => {
  const [result, setResult] = useState('');
  const [loading, setLoading] = useState(false);

  const testLogin = async () => {
    setLoading(true);
    setResult('Tentative de connexion...');
    
    try {
      console.log('🔐 Attempting login with:', {
        email: 'testuser@demo.com',
        password: '[HIDDEN]',
        apiUrl: `${API}/auth/login`
      });

      const response = await axios.post(`${API}/auth/login`, {
        email: 'testuser@demo.com',
        password: 'TestPass123!'
      });

      console.log('✅ Login successful:', response.data);
      setResult(`✅ SUCCÈS! Token: ${response.data.access_token.substring(0, 20)}...`);
      
      // Store in localStorage for testing
      localStorage.setItem('token', response.data.access_token);
      localStorage.setItem('user', JSON.stringify(response.data.user));
      
    } catch (error) {
      console.error('❌ Login failed:', error);
      setResult(`❌ ERREUR: ${error.response?.data?.detail || error.message}`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ 
      padding: '20px', 
      maxWidth: '600px', 
      margin: '0 auto',
      backgroundColor: '#f5f5f5',
      borderRadius: '10px'
    }}>
      <h1>🔧 Test d'Authentification</h1>
      
      <div style={{ marginBottom: '20px' }}>
        <p><strong>Backend URL:</strong> {BACKEND_URL || 'NON DÉFINI'}</p>
        <p><strong>API URL:</strong> {API}</p>
      </div>
      
      <button 
        onClick={testLogin}
        disabled={loading}
        style={{
          backgroundColor: '#4CAF50',
          color: 'white',
          padding: '15px 30px',
          fontSize: '18px',
          border: 'none',
          borderRadius: '5px',
          cursor: loading ? 'not-allowed' : 'pointer'
        }}
      >
        {loading ? 'Test en cours...' : 'TESTER LOGIN'}
      </button>
      
      <div style={{ 
        marginTop: '20px', 
        padding: '15px', 
        backgroundColor: 'white',
        borderRadius: '5px',
        minHeight: '50px'
      }}>
        <strong>Résultat:</strong>
        <pre>{result}</pre>
      </div>
    </div>
  );
};

export default TestAuth;